import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/styles/fonts-style.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/assets/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/CookieConsent.jsx");
